import React from 'react'
import { t } from '../i18n/i18n'
import { api } from './apiHelper'
import { CollectAndAuthResponse } from '../api/schemas/schema'
export const mapUserMessage = (hintCode: string, status: string): string => {
   if (status === 'pending') {
      switch (hintCode) {
         case 'outstandingTransaction':
         case 'noClient':
            return t('RFA1')

         case 'started':
            return t('RFA15b')

         case 'userMrtd':
            return t('RFA23')

         case 'userSign':
            return t('RFA9')

         case 'processing':
            return t('RFA21')

         default:
            return t('RFA21')
      }
   } else if (status === 'failed') {
      switch (hintCode) {
         case 'expiredTransaction':
            return t('RFA8')

         case 'certificateErr':
            return t('RFA16')

         case 'userCancel':
            return t('RFA6')

         case 'cancelled':
            return t('RFA3')

         case 'startFailed':
            return t('RFA17b')

         case 'userDeclinedCall':
         case 'transactionRiskBlocked':
            return null

         case 'notSupportedByUserApp':
            return t('UpdateToLatestVersionOfBankId')

         default:
            return t('RFA22')
      }
   } else if (status === 'complete') {
      return null
   }
}
export const startPolling = (
   setCollectionData: React.Dispatch<React.SetStateAction<CollectAndAuthResponse>>,
   setError: React.Dispatch<React.SetStateAction<string>>,
   login: () => void,
   clearSession: () => void,
   error: string,
   sessionId: string
) => {
   let transientErrorCount = 0
   const MAX_RETRIES = 3

   const intervalId = setInterval(async () => {
      try {
         const data = (await api().collectBankIdAndIssueTokenAsync(sessionId)).data
         transientErrorCount = 0
         setCollectionData(data)
         if (data.status === 'complete') {
            login()
            clearSession()
            clearInterval(intervalId)
         }
         if (error || data.status === 'failed') clearInterval(intervalId)
      } catch (err: any) {
         if (err.status === 404) {
            setError(t('NoAccountRegistered'))
            clearInterval(intervalId)
         } else {
            transientErrorCount++
            if (transientErrorCount >= MAX_RETRIES) {
               setError(err.status === 408 ? t('QRTimeout') : t('SomethingWentWrong'))
               clearInterval(intervalId)
            }
         }
      }
   }, 2000)
}
export const cancelAuth = (clearSession: () => void, sessionId: string) => {
   api().cancelBankIdRequestAsync(sessionId)
   clearSession()
}
